export const INSTITUTIONS_LIST_REFRESH_EVENT = "institutions-list-refresh";

export type InstitutionsListRefreshDetail = {
  businessUnitId: string;
};

/** Notify an active InstitutionsMainView to reload after a successful create (FR37). */
export function requestInstitutionsListRefresh(businessUnitId: string): void {
  if (!businessUnitId) {
    return;
  }
  window.dispatchEvent(
    new CustomEvent<InstitutionsListRefreshDetail>(
      INSTITUTIONS_LIST_REFRESH_EVENT,
      { detail: { businessUnitId } }
    )
  );
}
